import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function Enter({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                d="m9 19 1.4-1.425L6.825 14H16.5c1.25 0 2.313-.438 3.188-1.313C20.563 11.813 21 10.75 21 9.5c0-1.25-.438-2.313-1.313-3.188S17.75 5 16.5 5H16v2h.5c.7 0 1.292.242 1.775.725C18.758 8.208 19 8.8 19 9.5s-.242 1.292-.725 1.775c-.483.483-1.075.725-1.775.725H6.825L10.4 8.4 9 7l-6 6 6 6Z"
            />
        </svg>
    );
}

export default Enter;
